export const messages = {
  en: {
    auditCommunity: {
      title: 'Unaudited Communities',
      communityId: 'Community ID',
      name: 'Community Name',
      address: 'Address',
      nearbyLandmarks: 'Nearby Landmarks',
      cityCode: 'City Code',
      mapX: 'Latitude',
      mapY: 'Longitude',
      state: 'Status',
      operations: 'Operations',
      audit: 'Audit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      auditTitle: 'Audit Information',
      auditStatus: 'Audit Status',
      auditRemark: 'Reason',
      submit: 'Submit',
      selectAuditStatus: 'Please select audit status',
      inputReason: 'Please input reason'
    }
  },
  zh: {
    auditCommunity: {
      title: '未审核小区',
      communityId: '小区ID',
      name: '小区名称',
      address: '小区地址',
      nearbyLandmarks: '附近地标',
      cityCode: '城市编码',
      mapX: '小区维度',
      mapY: '小区经度',
      state: '状态',
      operations: '操作',
      audit: '审核',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      auditTitle: '审核信息',
      auditStatus: '审核状态',
      auditRemark: '原因',
      submit: '提交',
      selectAuditStatus: '请选择审核状态',
      inputReason: '请输入原因'
    }
  }
}